import { baseApi } from "./baseQuery";

const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (payload) => ({
        url: "api/v1/login",
        method: "POST",
        headers: payload.headers
      }),
    }),

    register: build.mutation({
      query: (payload) => ({
        url: "api/v1/register",
        method: "POST",
        body: payload.data,
        headers: payload.body
      }),
    }),

    notification: build.mutation({
      query: (payload) => ({
        url: "api/v1/user-notification-settings",
        method: "GET",
        body: payload
      }),
    }),


    verifyEmail: build.mutation({
      query: (payload) => ({
        url: `/api/v1/amazon-cognito-verify`,
        method: "POST",
        body: payload
      }),
    }),

    generateReferralCode: build.mutation({
      query: () => ({
        url: "api/v1/generate-referral-code",
        method: "POST",
      }),
    }),

    registerUserWithReferralCode: build.mutation({
      query: (payload) => ({
        url: "api/v1/register",
        method: "POST",
        body: payload
      }),
    }),

    createTrialonborading: build.mutation({
      query: (payload) => ({
        url: `/api/v1/onboarding_3_screens`,
        method: "POST",
        body: payload.body,
        headers: payload.header
      }),
    }),

    googleSignUp: build.mutation({
      query: (body) => ({
        url: "api/v1/google-signup",
        method: "POST",
        headers: body
      }),
    }),

    addGaAccountForNewUser: build.mutation({
      query: () => ({
        url: "api/v1/added-demo-ga-account",
        method: "POST",
      }),
    }),
  }),

  // @ts-ignore
  overrideExisting: module.hot?.status() === "apply",
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useNotificationMutation,
  useVerifyEmailMutation,
  useCreateTrialonboradingMutation,
  useGoogleSignUpMutation,
  useAddGaAccountForNewUserMutation,
  // referral code
  useGenerateReferralCodeMutation,
  useRegisterUserWithReferralCodeMutation,
} = authApi;
